import React from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import { When } from 'UI/components/atoms';
import FPRadioGroup from 'UI/components/molecules/FPRadioGroup';
import NumberedForm from 'UI/components/molecules/NumberedForm';
import { ContactRole } from 'UI/constants/entityTypes';

import { FORM_FIELDS_MAP } from '../../fields';

import {
  COMPANY_SKIP_DUPLICATES_OPTIONS,
  CONTACT_TYPE_OPTIONS,
  COPIES,
  SKIP_DUPLICATES_OPTIONS,
  SKIP_EXISTING_CONTACTS_ID
} from './ImportOptionsForm.constants';

export const ImportOptionsForm = ({ isCompany = false }) => {
  const { control } = useFormContext();

  return (
    <NumberedForm.Item title={COPIES.titles.importOptions}>
      <When condition={!isCompany}>
        <Controller
          as={
            <FPRadioGroup
              name={FORM_FIELDS_MAP.prospectType.key}
              options={CONTACT_TYPE_OPTIONS}
              label={COPIES.importOptions.fields.importContactsAs}
            />
          }
          control={control}
          defaultValue={String(ContactRole.Candidate)}
          name={FORM_FIELDS_MAP.prospectType.key}
          onChange={([event]) => event.target.value}
          onChangeName="onChange"
          valueName="value"
        />
      </When>

      <Controller
        as={
          <FPRadioGroup
            name={FORM_FIELDS_MAP.skipDuplicates.key}
            options={isCompany ? COMPANY_SKIP_DUPLICATES_OPTIONS : SKIP_DUPLICATES_OPTIONS}
            label={
              isCompany
                ? COPIES.importOptions.fields.company.skipDuplicates
                : COPIES.importOptions.fields.skipDuplicates
            }
          />
        }
        control={control}
        defaultValue={SKIP_EXISTING_CONTACTS_ID}
        name={FORM_FIELDS_MAP.skipDuplicates.key}
        onChange={([event]) => event.target.value}
        onChangeName="onChange"
        valueName="value"
      />
    </NumberedForm.Item>
  );
};
